import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class FuneralAndEstateExpenseType extends Enum {
  static ACCOUNTING_FEES = {
    key: 'accounting_fees',
    get value() {
      return Lang.t('liability.accounting-fees');
    }
  };

  static ADMINISTRATION_FEES = {
    key: 'administration_fees',
    get value() {
      return Lang.t('liability.administration-fees');
    }
  };

  static APPRAISAL_FEES = {
    key: 'appraisal_fees',
    get value() {
      return Lang.t('liability.appraisal-fees');
    }
  };

  static FUNERAL_HOME_FEES = {
    key: 'funeral_home_fees',
    get value() {
      return Lang.t('liability.funeral-home-fees');
    }
  };

  static LEGAL_FEES = {
    key: 'legal_fees',
    get value() {
      return Lang.t('liability.legal-fees');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };

  static PROBATE_REFEREE_FEE = {
    key: 'probate_referee_fee',
    get value() {
      return Lang.t('liability.probate-referee-fee');
    }
  };

  static PROBATE_APPLICATION_FEE = {
    key: 'probate_application_fee',
    get value() {
      return Lang.t('liability.probate-application-fee');
    }
  };
}
